import { Routes } from '@angular/router';
import { CemRoutes } from '@app/cem/cem.routing';
import { ForecastsRoutes } from '@app/forecasts/forecasts.routing';
import { ReportsRoutes } from '@app/reports/reports.routing';
import { AccessDeniedComponent } from '@app/shared-pages/auth/access-denied/access-denied.component';
import { AuthorizeComponent } from '@app/shared-pages/auth/authorize/authorize.component';
import { Error404Component } from '@app/shared-pages/error-404/error-404.component';
import { SectionTemplateComponent } from '@app/shared/layouts/components/section-template/section-template.component';
import { DefaultLayoutComponent } from '@app/shared/layouts/default/default-layout.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'projects/home',
    pathMatch: 'full'
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    data: {
      title: 'Map'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: '',
        component: SectionTemplateComponent,
        data: {
          title: 'Template'
        },
        children: [
          {
            path: '',
            children: [...CemRoutes],
            data: {
              preload: true,
              title: 'CEM'
            }
          },
          {
            path: 'cem',
            children: [...CemRoutes],
            data: {
              preload: true,
              title: 'CEM'
            }
          },
          {
            path: 'reports',
            children: [...ReportsRoutes],
            data: {
              title: 'Reports'
            }
          },
          {
            path: 'forecasts',
            children: [...ForecastsRoutes],
            data: {
              title: 'Forecasts'
            }
          },
          {
            path: 'authorize',
            component: AuthorizeComponent,
            data: {
              title: 'Authorize'
            }
          },
          {
            path: '**',
            component: Error404Component,
            data: {
              title: '404'
            }
          }
        ]
      }
    ]
  }
];
